

























































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import data from "@/ts/FormData";
import ErrorMessages from "@/ts/constants/FormErrorMessages";
import { IContactVueModel } from '@/ts/models/IContactVueModel';
import AddressInfo from '@/views/shared/AddressInfo.vue';

@Component({
    props: {
        form: {
            type: Object as () => IContactVueModel
        },
        contactType: {
            type: String
        },
        isReadOnly: {
            type: Boolean
        },
        hideCountry: {
          type: Boolean
        },
        hideOrganizationName: {
          type: Boolean
        },
        nameNotRequired: {
          type: Boolean
        }
    },
    components: {
        AddressInfo
    },
})
export default class ContactInfo extends Vue {

    name: string = "contact-info";
    hasAddressError: boolean = false;
    errorMsgs = ErrorMessages;

    contactId: string = "";

    nameErrorMessage: string = "";
    firstNameErrorMessage: string = "";
    lastNameErrorMessage: string = "";

    mounted() {
        this.$watch("hasErrors", (n, o) => {
            this.$emit("update:hasContactError", this.hasErrors);
            this.$props.form.hasErrors = this.hasErrors;
        }, { immediate: !this.$props.isReadOnly });

        if (func.isNullOrEmpty(this.$props.form.id)) {
            this.$props.form.id = data.getNewId();
            this.contactId = this.$props.form.id;
        }

        this.$props.form.contactType = this.$props.contactType;
        this.nameErrorMessage = `A ${this.$props.contactType}${this.$props.hideOrganizationName ? '' : ' Organization'} Name Is Required`;
        this.firstNameErrorMessage = `A ${this.$props.contactType} First Name Is Required`;
        this.lastNameErrorMessage = `A ${this.$props.contactType} Last Name Is Required`;
    }

    get isNameError(): boolean {
        return func.isNullOrEmpty(this.$props.form.name);
    }

    get isPhoneError(): boolean {
        return func.isNullOrEmpty(this.$props.form.phone);
    }

    get isFirstNameError(): boolean {
      if (this.$props.nameNotRequired) return false;
        return func.isNullOrEmpty(this.$props.form.firstName);
    }

    get isLastNameError(): boolean {
      if (this.$props.nameNotRequired) return false;
        return func.isNullOrEmpty(this.$props.form.lastName);
    }

    get hasErrors(): boolean {
        return this.isNameError || this.isPhoneError || this.isFirstNameError || this.isLastNameError || this.hasAddressError;
    }
}
